import http from './httpService';

export function getAllUnitsOfMeasure() {
	return http.get('/UnitsOfMeasure');
}

export default { getAllUnitsOfMeasure };
